import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu"
import { ROLES } from "@/consts/permissions"
import { useAuth } from "@/hooks/useAuth"
import { ROLE_OPTIONS, normalizeRoleValue } from "@/types/admin/admin.types"
import { FlaskConical, RotateCcw } from "lucide-react"
import { useTranslation } from "react-i18next"

const DevRoleSwitcher = () => {
  const { switchRole, stopRoleSwitch, isImpersonating, originalRole } =
    useAuth()
  const { t } = useTranslation()

  // Only render in dev builds AND only for developers (real or impersonating)
  const realRole = isImpersonating ? originalRole : localStorage.getItem("role")
  const isRealDeveloper =
    String(realRole).toLowerCase() === ROLES.DEVELOPER ||
    String(realRole) === "4"

  if (!isRealDeveloper) return null

  const actAsRoleOptions = ROLE_OPTIONS.filter((role) => role.value !== 4)

  const currentRoleLevel = String(
    normalizeRoleValue(localStorage.getItem("role") ?? "1"),
  )

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel className="text-muted-foreground flex items-center gap-2 text-xs font-normal">
        <FlaskConical className="h-3.5 w-3.5" />
        {t("devTools.title")}
      </DropdownMenuLabel>

      <DropdownMenuSub>
        <DropdownMenuSubTrigger className="cursor-pointer">
          <FlaskConical className="mr-2 h-4 w-4" />
          {t("devTools.actAs")}
          {isImpersonating && (
            <span className="text-primary ml-auto text-[10px] font-semibold uppercase">
              {t("devTools.activeBadge")}
            </span>
          )}
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent className="w-48">
          <DropdownMenuRadioGroup
            value={currentRoleLevel}
            onValueChange={(v) => {
              const next = Number(v)
              if (!Number.isNaN(next)) switchRole(next)
            }}
          >
            {actAsRoleOptions.map((opt) => (
              <DropdownMenuRadioItem
                key={opt.value}
                value={String(opt.value)}
                className="cursor-pointer"
              >
                {t(`devTools.roles.${opt.label}`, opt.label)}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuSubContent>
      </DropdownMenuSub>

      {isImpersonating && (
        <DropdownMenuItem
          className="cursor-pointer"
          onSelect={() => stopRoleSwitch()}
        >
          <RotateCcw className="mr-2 h-4 w-4" />
          {t("devTools.restoreOriginal")}
        </DropdownMenuItem>
      )}
    </>
  )
}

export default DevRoleSwitcher
